export const selectSubscriptionExpiration = (state) =>
  state.subscription.subscriptionExpiration
